'use strict'

angular.module('app').factory('authInterceptor', ['$q', '$injector', 'STORAGE_KEYS', function ($q, $injector, STORAGE_KEYS) {
  var isRefreshing = false
  var refreshQueue = []

  function processQueue(newToken) {
    var queue = refreshQueue.slice()
    refreshQueue = []
    queue.forEach(function (cb) { cb(newToken) })
  }

  function triggerRefresh(authService) {
    if (!isRefreshing) {
      isRefreshing = true
      authService.refreshToken().then(
        function (newToken) {
          isRefreshing = false
          processQueue(newToken)
        },
        function () {
          isRefreshing = false
          authService.logout()
          processQueue(null)
        }
      )
    }
  }

  return {
    request: function (config) {
      if (config._skipTokenCheck) return config

      var accessToken = localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN)
      if (!accessToken) return config

      var authService = $injector.get('authService')
      var session = authService.sessionInfo()
      var minutesLeft = session ? session.minutesLeft : null

      if (minutesLeft !== null && minutesLeft <= 0) {
        config._skipTokenCheck = true
        triggerRefresh(authService)

        return $q(function (resolve) {
          refreshQueue.push(function (newToken) {
            config.headers = config.headers || {}
            if (newToken) {
              config.headers['Authorization'] = 'Bearer ' + newToken
            }
            resolve(config)
          })
        })
      }
      return config
    },

    responseError: function (rejection) {
      if (rejection.status !== 401) {
        return $q.reject(rejection)
      }

      var authService = $injector.get('authService')

      if (rejection.config._retried) {
        authService.logout()
        return $q(function () {})
      }

      triggerRefresh(authService)

      return $q(function (resolve) {
        refreshQueue.push(function (newToken) {
          if (!newToken) {
            return
          }
          var $http = $injector.get('$http')
          rejection.config._retried = true
          rejection.config.headers = rejection.config.headers || {}
          rejection.config.headers['Authorization'] = 'Bearer ' + newToken
          resolve($http(rejection.config))
        })
      })
    }
  }
}])
